<!--
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-19 18:10:17
 * @Description: TODO
-->
<template>
  <div class="summary-div col">
<!--    <div class="row fill bg-color al-center">-->
<!--      <div class="title color1 fill mb15">交易金额(总)</div>-->
<!--      <div class="fill value mt15"><dv-digital-flop :config="{...config1,number:[newData.consultMoney]}" style=""/></div>-->
<!--    </div>-->
<!--    <div class="row fill bg-color al-center">-->
<!--      <div class="title color1 fill mb15">交易金额(年)</div>-->
<!--      <div class="fill value mt15"><dv-digital-flop :config="{...config1,number:[newData.dateTimeMoney]}" style=""/></div>-->
<!--    </div>-->
<!--    <div class="row fill mt10">-->
<!--      <div class="row fill bg-color al-center">-->
<!--        <div class="title color2 fill mb15">注册会员</div>-->
<!--        <div class="fill value mt15"><dv-digital-flop :config="{ ...config2, number: [data.shop] }" /></div>-->
<!--      </div>-->
<!--      <div class="row fill ml10 bg-color al-center">-->
<!--        <div class="title color2 fill mb15">交易数</div>-->
<!--        <div class="fill value mt15"><dv-digital-flop :config="{ ...config3, number: [data.order] }" /></div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="row fill mt10">-->
<!--      <div class="row fill bg-color al-center">-->
<!--        <div class="title color3 fill mb15">货品种类</div>-->
<!--        <div class="fill value mt15"><dv-digital-flop :config="{ ...config4, number: [data.goods] }" /></div>-->
<!--      </div>-->
<!--      <div class="row fill ml10 bg-color al-center">-->
<!--        <div class="title color3 fill mb15">问询量</div>-->
<!--        <div class="fill value mt15"><dv-digital-flop :config="{ ...config5, number: [data.ask] }" /></div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="row fill mt10">-->
<!--      <div class="row fill bg-color al-center">-->
<!--        <div class="title color2 fill mb15">注册会员</div>-->
<!--        <div class="fill value mt15"><dv-digital-flop :config="{ ...config2, number: [data.shop] }" /></div>-->
<!--      </div>-->
<!--      <div class="row fill ml10 bg-color al-center">-->
<!--        <div class="title color3 fill mb15">问询量</div>-->
<!--        <div class="fill value mt15"><dv-digital-flop :config="{ ...config5, number: [data.ask] }" /></div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="row fill mt10">
      <div class="row fill bg-color al-center">
        <div class="title color2 fill mb15">注册会员</div>
        <div class="fill value mt15"><dv-digital-flop :config="{ ...config2, number: [data.registerMember] }" /></div>
      </div>
      <div class="row fill ml10 bg-color al-center">
        <div class="title color3 fill mb15">昨日新增</div>
        <div class="fill value mt15"><dv-digital-flop :config="{ ...config5, number: [data.newAdditionToday] || 0  }" /></div>
      </div>
    </div>
    <div class="row fill mt10">
      <div class="row fill bg-color al-center">
        <div class="title color2 fill mb15">企业会员</div>
        <div class="fill value mt15"><dv-digital-flop :config="{ ...config2, number: [data.corporateMember] }" /></div>
      </div>
      <div class="row fill ml10 bg-color al-center">
        <div class="title color3 fill mb15">vip会员</div>
        <div class="fill value mt15"><dv-digital-flop :config="{ ...config5, number: [data.vipMember] }" /></div>
      </div>
    </div>
    <div class="row fill mt10">
      <div class="row fill bg-color al-center">
        <div class="title color2 fill mb15">问询量 <br> (昨日)</div>
        <div class="fill value mt15"><dv-digital-flop :config="{ ...config2, number: [data.todayInquiryVolume] }" /></div>
      </div>
      <div class="row fill ml10 bg-color al-center">
        <div class="title color3 fill mb15">问询量 <br> (本月)</div>
        <div class="fill value mt15"><dv-digital-flop :config="{ ...config5, number: [data.inquiryVolumeThisMonth] }" /></div>
      </div>
    </div>
  </div>
</template>

<script>
function formatter (number) {
  const numbers = number.toString().split('').reverse()
  const segs = []
  while (numbers.length) segs.push(numbers.splice(0, 3).join(''))
  return segs.join(',').split('').reverse().join('')
}

const commponConfig = {
  style: { fontWeight: 'bold', fontSize: 26 },
  formatter
}

export default {
  name: 'CompanySummary',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      config1: {
        number: [0],
        content: '¥{nt}万',
        ...commponConfig
      },
      config2: {
        number: [0],
        content: '{nt}',
        ...commponConfig
      },
      config3: {
        number: [0],
        content: '{nt}',
        ...commponConfig
      },
      config4: {
        number: [0],
        content: '{nt}',
        ...commponConfig
      },
      config5: {
        number: [0],
        content: '{nt}',
        ...commponConfig
      }
    }
  },
  mounted () {
    console.info('----mounted----mounted')
  }
}
</script>

<style lang="less">
.summary-div {
  height: 100%;

  .bg-color {
    background-color: #0f3058;
    opacity: 0.7;
  }

  .title {
    font-size: 30px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
  }
  .value{
    max-height: 80px;
  }
  .color1 {
    color: #f59a23;
  }
  .color2 {
    color: #25e49c;
    font-size: 22px;
  }
  .color3 {
    color: #26defd;
    font-size: 22px;
  }
}
</style>
